import React from "react";
import Brand from "../Base/Brand";

const LayoutMessage = ({ children }) => {
  return (
    <div
      className="bg-[white] flex-col inline-flex items-center p-[3rem]"
      style={{ boxShadow: "0px 0px 15px 0px rgba(0,0,0,0.28)" }}
    >
      <div className="mb-8 flex justify-center text-center">
        <Brand className="w-full h-full max-w-[20rem]" />
      </div>
      <div className="flex w-full items-center justify-center">{children}</div>
    </div>
  );
};

export default LayoutMessage;
